const CheckedIcon = () => (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect x="0.5" y="0.5" width="15" height="15" rx="3.5" fill="#B4ACFB" stroke="#ACACAC" />
    <line x1="3.70711" y1="8.08" x2="7.34347" y2="11.7164" stroke="#140C40" strokeWidth="2" />
    <line x1="13.7071" y1="4.70711" x2="6.43438" y2="11.9798" stroke="#140C40" strokeWidth="2" />
  </svg>
)

export default CheckedIcon
